import { render, staticRenderFns } from "./aturizarEncuesstas.vue?vue&type=template&id=aceb5c26&scoped=true&"
import script from "./aturizarEncuesstas.vue?vue&type=script&lang=js&"
export * from "./aturizarEncuesstas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aceb5c26",
  null
  
)

export default component.exports